export const PROVIDERS = [
  "google",
  "okta"
];

export type TAuthProvider = typeof PROVIDERS[number];

const AUTH_ENV = process.env.NODE_ENV === "development" ? "dev-local/" : "";

export function getAuthenticationUrl(authProvider: TAuthProvider) {
  const url = `${process.env.REACT_APP_API_BASE}/auth/${authProvider}/${AUTH_ENV}authorize`;
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export function getAuthenticationToken(authProvider: TAuthProvider, query: string) {
  const callbackUrl = `${process.env.REACT_APP_API_BASE}/auth/${authProvider}/${AUTH_ENV}callback${query}`;

  return fetch(callbackUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}
